// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2UoUn","buttons":"RemoveExpirationActionButtons_buttons__2X2cn"};